import React, { forwardRef, useImperativeHandle } from "react";
import { useNotification } from "contexts/NotificationContext";
import { Upload, UploadFileInfo, UploadOnAddEvent, UploadOnRemoveEvent } from "@progress/kendo-react-upload";

export type FileUploadRef = {
  clearFile: () => void;
};

type FileUploadButtonProps = {
  onFileChange: (file: File | null) => void;
  uplFile: File | null;
};

const FileUploadButton = forwardRef<FileUploadRef, FileUploadButtonProps>(({ onFileChange, uplFile }, ref) => {
  const notification = useNotification();
  const [files, setFiles] = React.useState<UploadFileInfo[]>([]);

  const clearFile = () => {
    setFiles([]);
    onFileChange(null);
    notification.showNotification("File removed.");
  };

  useImperativeHandle(ref, () => ({
    clearFile,
  }));
  
  const handleAdd = (event: UploadOnAddEvent) => {
    const newFiles = event.affectedFiles;
    if (newFiles.length === 0) {
      return;
    }
    // For single file
    const fileInfo = newFiles[0];
    setFiles([fileInfo]);
    const raw = fileInfo.getRawFile && fileInfo.getRawFile();
    
    if (raw) {
      onFileChange(raw);
      notification.showNotification(`File "${raw.name}" uploaded.`);
    }
  };

  const handleRemove = (event: UploadOnRemoveEvent) => {
    setFiles([]);
    onFileChange(null);
    notification.showNotification(`File removed.`);
  };

  return (
    <div className="upload‑button‑wrapper">
      <Upload
        multiple={false}
        autoUpload={false}
        showActionButtons={false}
        accept=".xlsx"
        files={files}
        onAdd={handleAdd}
        onRemove={handleRemove}
      />
    </div>
  );
});

export default FileUploadButton;
